// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"74454d4c87909dbe","964":"22a737e5960f76ad"}[chunkId] + ".js";
};